import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export class NewMessageButton extends React.Component {
  render() {
    const { buttonClassName, iconClassName } = this.props;
    let buttonClass = "btn btn-link theme";
    buttonClass = buttonClassName ? buttonClass + ' ' + buttonClassName : buttonClass;

    return (
      <button type="button"
        className={buttonClass}
        onClick={this.props.onClick}
        data-qa-item={ this.props.qaTag }
      >
      <span
        className={iconClassName || 'fa-solid fa-pen-to-square me-1'}
      ></span>
        
        <FormattedMessage { ...this.props.buttonName } />
      </button>
    );
  }
}

NewMessageButton.propTypes = {
  qaTag: PropTypes.string,
  buttonName: PropTypes.object,
  onClick: PropTypes.func,
  buttonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
};